<template>
    <div>
        <div class="margin-bottom-5" v-if="type == 'query'">
            <vButton
                v-if="
                    formData.orderStatus === 1 &&
                    this.handleAuth('tracking.change.acceptance')
                "
                class="margin-right-10"
                theme="success"
                @click="accept"
                >{{
                    $t("fbb.expresspackage.acceptance", {
                        defaultValue: "受理",
                    })
                }}</vButton
            >
            <vButton
                v-if="
                    formData.orderStatus === 3 &&
                    this.handleAuth('tracking.change.acceptancesuccess')
                "
                class="margin-right-10"
                theme="primary"
                @click="acceptSuccess"
                >{{
                    $t("fbb.expresspackage.accepted_successfully", {
                        defaultValue: "受理成功",
                    })
                }}</vButton
            >
            <vButton
                v-if="
                    formData.orderStatus === 3 &&
                    this.handleAuth('tracking.change.acceptancesuccess')
                "
                class="margin-right-10"
                theme="error"
                @click="acceptFail"
                >{{
                    $t("fbb.expresspackage.acceptance_failed", {
                        defaultValue: "受理失败",
                    })
                }}</vButton
            >
        </div>
        <compWrapper
            :title="
                $t('global.common.base_information', {
                    defaultValue: '基本信息',
                })
            "
            theme="primary"
        >
            <div>
                <compFormQuery
                    v-if="type == 'query'"
                    :formdata="getBase"
                    :value="formData"
                    :labelWidth="120"
                    placeholder="--"
                ></compFormQuery>
            </div>
        </compWrapper>

        <compWrapper
            v-if="type === 'query'"
            :title="
                $t('fbb.expresspackage.acceptance_information', {
                    defaultValue: '受理信息',
                })
            "
            theme="primary"
        >
            <vButtonGroup
                v-if="
                    this.formData.orderStatus === 2 &&
                    handleAuth('tracking.change.acceptance')
                "
                class="absolute"
                style="right: 20px; top: 3px"
            >
                <vButton
                    class="margin-right-20"
                    theme="success"
                    @click="confirm"
                    >{{
                        $t("fbb.expresspackage.confirm_carrier_acceptance", {
                            defaultValue: "确认承运商受理",
                        })
                    }}</vButton
                >
            </vButtonGroup>
            <div>
                <compFormQuery
                    :formdata="getBase1"
                    :value="formData"
                    :labelWidth="120"
                    placeholder="--"
                ></compFormQuery>
            </div>
            <!-- <div v-if="this.formData.orderStatus===2" class="text-right">
                <vButton class="margin-right-20" theme="info" @click="confirm">{{$t('',{defaultValue:'确认承运商受理'})}}</vButton>
            </div> -->
        </compWrapper>
        <compWrapper
            :title="
                $t('global.common.operate_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
            v-if="type === 'query'"
        >
            <compLog
                class="margin-layout"
                :data="logList"
                :columns="logcolumn"
            ></compLog>
        </compWrapper>
        <!-- 公共弹框 -->
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="closemodalprops"
        >
            <component
                ref="cusref"
                :is="modalProps.component"
                v-bind="modalProps"
                v-on="modalProps.on"
                @on-close="closemodalprops"
            ></component>
        </compModal>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
    HttpGetTrackingChangeDetail,
    HttpCarrierConfirmAdmin,
    HttpChangeStatusAdmin,
    HttpAcceptanceAdmin,
} from "@/service/expresspackage";
export default {
    props: ["activeids", "querytype"],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
    },
    data() {
        return {
            id: this.$route.query.id || this.activeids,
            type: this.$route.params.type || this.querytype,
            formData: {},
            loading: false,
            logList: [],
            modalProps: {},
        };
    },
    created() {
        this.update();
    },
    computed: {
        ...mapGetters("dictionary", []),
        getBase() {
            return [
                {
                    label: this.$t("fbb.inbound.logistics_singleno", {
                        defaultValue: "物流单号",
                    }),
                    key: "trackingNo",
                    props: {
                        readonly: this.type !== "add",
                    },
                },
                {
                    label: this.$t("global.common.source_number", {
                        defaultValue: "来源单号",
                    }),
                    key: "sourceNo",
                    props: {
                        readonly: this.type !== "add",
                    },
                },
                {
                    label: this.$t("global.common.deliveryWarehouse", {
                        defaultValue: "发货仓库",
                    }),
                    key: "orgWarehouseCode",
                    props: {
                        readonly: true,
                    },
                },
                {
                    label: this.$t("erp.b2c.shipping_method", {
                        defaultValue: "发货方式",
                    }),
                    key: "carrierServiceCode",
                    props: {
                        readonly: true,
                    },
                },
                {
                    label: this.$t("fbb.expresspackage.recipient_name", {
                        defaultValue: "收件人姓名",
                    }),
                    key: "originalRecipientName",
                    props: {
                        readonly: true,
                    },
                },
                {
                    label: this.$t("fbb.receiver.query", {
                        defaultValue: "收货地址",
                    }),
                    key: "originalRecipientAddress",
                    props: {
                        readonly: true,
                    },
                },
                {
                    label: this.$t("fbb.expresspackage.recipient_phone", {
                        defaultValue: "收件人电话",
                    }),
                    key: "originalRecipientPhone",
                    props: {
                        readonly: true,
                    },
                },
                {
                    label: this.$t("fbb.expresspackage.process_type", {
                        defaultValue: "处理类型",
                    }),
                    key: "handleType",
                    tag: "vSelect",
                    options: [
                        {
                            value: 1,
                            label: this.$t("fbb.expresspackage.recall", {
                                defaultValue: "召回",
                            }),
                        },
                        {
                            value: 2,
                            label: this.$t(
                                "fbb.expresspackage.change_address",
                                {
                                    defaultValue: "更址",
                                }
                            ),
                        },
                        {
                            value: 3,
                            label: this.$t(
                                "fbb.expresspackage.abnormal_in_transit",
                                {
                                    defaultValue: "在途异常",
                                }
                            ),
                        },
                    ],
                },
                {
                    label: this.$t("fbb.expresspackage.new_recipient_name", {
                        defaultValue: "新收件人姓名",
                    }),
                    key: "newRecipientName",
                    tag: "vInput",
                    show: this.formData.handleType === 2,
                },
                {
                    label: this.$t("fbb.expresspackage.new_shipping_address", {
                        defaultValue: "新收货地址",
                    }),
                    key: "newRecipientAddress",
                    tag: "vInput",
                    show: this.formData.handleType === 2,
                },
                {
                    label: this.$t("fbb.expresspackage.new_recipient_phone", {
                        defaultValue: "新收件人电话",
                    }),
                    key: "newRecipientPhone",
                    tag: "vInput",
                    show: this.formData.handleType === 2,
                },
                {
                    label: this.$t("global.common.notes", {
                        defaultValue: "备注",
                    }),
                    key: "customerRemark",
                    tag: "vTextarea",
                    required: false,
                },
            ];
        },
        getBase1() {
            return [
                {
                    label: this.$t("fbb.expresspackage.whether_accept", {
                        defaultValue: "是否受理",
                    }),
                    key: "carrierIsAcceptance",
                    render: (h) => {
                        return this.formData.carrierIsAcceptance === 1
                            ? "是"
                            : this.formData.carrierIsAcceptance === 2
                            ? "否"
                            : "--";
                    },
                },
                {
                    label: this.$t("", { defaultValue: "CASE ID" }),
                    key: "caseId",
                },
                {
                    label: this.$t("global.common.notes", {
                        defaultValue: "备注",
                    }),
                    key: "acceptanceRemark",
                },
            ];
        },
        logcolumn() {
            return [
                {
                    title: this.$t("global.common.operator", {
                        defaultValue: "操作人",
                    }),
                    key: "opUserName",
                },
                {
                    title: this.$t("global.common.operate_time", {
                        defaultValue: "操作时间",
                    }),
                    key: "opAt",
                },
                {
                    title: this.$t("global.common.notes", {
                        defaultValue: "备注",
                    }),
                    key: "opRemark",
                },
            ];
        },
    },
    methods: {
        accept() {
            this.modalProps = {
                show: true,
                alert: "message",
                title: this.$t("fbb.expresspackage.acceptance", {
                    defaultValue: "受理",
                }),
                width: 460,
                params: { id: this.id, status: 2 },
                formdata: [
                    {
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        label: this.$t("global.common.notes", {
                            defaultValue: "备注",
                        }),
                        required: false,
                    },
                ],
                ajaxRequest: HttpAcceptanceAdmin,
            };
        },
        acceptSuccess() {
            this.modalProps = {
                show: true,
                alert: "success",
                width: 460,
                title: this.$t("fbb.expresspackage.accepted_successfully", {
                    defaultValue: "受理成功",
                }),
                params: { ids: this.id, status: 4 },
                formdata: [
                    {
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        label: this.$t("global.common.notes", {
                            defaultValue: "备注",
                        }),
                        required: false,
                    },
                ],
                ajaxRequest: HttpChangeStatusAdmin,
            };
        },
        acceptFail() {
            this.modalProps = {
                show: true,
                alert: "error",
                title: this.$t("fbb.expresspackage.acceptance_failed", {
                    defaultValue: "受理失败",
                }),
                width: 460,
                params: { ids: this.id, status: 5 },
                formdata: [
                    {
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        label: this.$t("global.common.notes", {
                            defaultValue: "备注",
                        }),
                        required: false,
                    },
                ],
                ajaxRequest: HttpChangeStatusAdmin,
            };
        },
        closemodalprops() {
            this.$emit("on-openCloseable");
            this.modalProps = {};
        },
        update() {
            if (this.type == "add") return;
            HttpGetTrackingChangeDetail({
                id: this.id,
            }).then(
                (res) => {
                    this.formData = res.data;
                    this.logList = res.data.logEntities;
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        async confirm() {
            this.modalProps = {
                show: this.handleAuth("tracking.change.acceptance"),
                title: this.$t("global.datepicker.confirm", {
                    defaultValue: "确认",
                }),
                alert: "success",
                showDesc: false,
                width: "middle",
                params: { id: this.id },
                ajaxRequest: HttpCarrierConfirmAdmin,
                formdata: [
                    {
                        tag: "vSelect",
                        key: "carrierIsAcceptance",
                        label: this.$t("fbb.expresspackage.whether_accept", {
                            defaultValue: "是否受理",
                        }),
                        options: [
                            {
                                value: "1",
                                label: this.$t("boss.purchase.correct", {
                                    defaultValue: "是",
                                }),
                            },
                            {
                                value: "2",
                                label: this.$t("boss.purchase.deny", {
                                    defaultValue: "否",
                                }),
                            },
                        ],
                    },
                    {
                        tag: "vInput",
                        key: "caseId",
                        label: "CASE ID",
                    },
                    {
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        label: this.$t("boss.purchase.notes", {
                            defaultValue: "备注",
                        }),
                        required: false,
                    },
                ],
                on: {
                    "on-confirm": this.cancel,
                },
            };
        },
    },
};
</script>
